<template>
  <ProjectPage v-bind="projectMeta" :nextProject="nextProject" /> 
</template>

<script>
  import ProjectPage from './ProjectPage';
  import { slugFunctions } from '../mixins'; 

  export default {
    name: 'ProjectWrapper',
    props: ['projectsMeta', 'siteMeta', 'slug'],
    mixins: [slugFunctions],
    components: {
      ProjectPage,
    },
    computed: {
      projectMeta() {
        for(let i = 0; i < this.projectsMeta.length; i++) {
          if(this.toSlug(this.projectsMeta[i].title) === encodeURI(this.slug)) {
            return this.projectsMeta[i]
          }
        } 
        return {};
      },
      nextProject() {
        for(let i = 0; i < this.projectsMeta.length; i++) {
          if(this.toSlug(this.projectsMeta[i].title) === encodeURI(this.slug)) {
            if(i + 1 < this.projectsMeta.length) {
              return this.projectsMeta[i + 1]
            } else {
              return this.projectsMeta[0]
            }
          }
        } 
        return {};
      },
    },
  }
</script>
